import authentication from './authentication/reducer';
import layout from './layout/reducer';

const reducers = {
	authentication,
	layout,
};

export default reducers;
